import React from 'react';
import {ContextMenuSchema} from "../../SmuOrders/components/ContextMenu";
import User from "../../../models/User";
import {HistoryOutlined, SearchOutlined} from "@ant-design/icons";

import './UseContextMenu.css';

const UserContextMenu = ({ contextMenuPosition, editUser }: { contextMenuPosition: ContextMenuSchema, editUser: (record: User, disabled: boolean) => void}): JSX.Element => {
    const { record, visible, x, y } = contextMenuPosition;

    return (
        <>
            {
                (visible && record) && (
                    <ul className="popupcm" style={{left: `${x}px`, top: `${y}px`, padding: '5px'}}>
                        <span>Email: <b>{record.email}</b></span>
                        <hr style={{ border: '0', borderTop: '1px solid #c3c3c3'}}/>
                        <li onClick={() => { editUser(record, true) }}><SearchOutlined style={{ marginRight: '3px' }} /> Ver</li>
                        <li onClick={() => { editUser(record, false) }}><HistoryOutlined style={{ marginRight: '3px' }} /> Editar</li>
                    </ul>
                )
            }
        </>
    );
};

export default UserContextMenu;